import React from 'react'
import { Box } from 'grommet'
import styled, { keyframes } from 'styled-components'
import { ProductLogo } from '../../index'

const DataFlow = ({ connectors, ...rest }) => {  
  return (
    <Box
      direction="row"
      margin={{ top: "xsmall" }}
      {...rest}
    >
      {
        connectors.map((item, index) => {
          const isLast = connectors.length-1 === index
          const { name, ...rest } = item
          return (
            <Box direction="row" align="center">
              <ProductLogo key={index} name={name} size="small" {...rest} />
              {
                !isLast && (
                  <Box key={index}>
                    <Connector
                      height="1px"
                      width="48px"
                      round="small"
                      margin={{
                        horizontal: "14px"
                      }}
                    />
                    <Spinner key={index} />
                  </Box>
                )
              }
            </Box>
          )
        })
      }
    </Box>
  )
}


DataFlow.defaultProps = {
  connectors: []
}

const Spinner = () => (
  <SpinnerSVG width="14px" height="14px" viewBox="0 0 140 140" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsClink="http://www.w3.org/1999/xlink">
    <defs>
      <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="linearGradient-1">
        <stop stop-color="#D8F0FF" offset="0%"></stop>
        <stop stop-color="#E9EBF3" offset="100%"></stop>
      </linearGradient>
    </defs>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="icons8-iris-scan" fillRule="nonzero">
          <path d="M14.4511111,79.7222222 C13.8911111,76.5138889 13.6111111,73.2511111 13.6111111,70 C13.6111111,38.9083333 38.9083333,13.6111111 70,13.6111111 C101.091667,13.6111111 126.388889,38.9083333 126.388889,70 C126.388889,73.2511111 126.108889,76.5138889 125.548889,79.7222222 L14.4511111,79.7222222 Z" id="Path" fill="#DFF0FE"></path>
          <path d="M70,15.5555556 C100.022222,15.5555556 124.444444,39.9777778 124.444444,70 C124.444444,72.5977778 124.257778,75.2033333 123.888333,77.7777778 L16.1116667,77.7777778 C15.7422222,75.2033333 15.5555556,72.5977778 15.5555556,70 C15.5555556,39.9777778 39.9777778,15.5555556 70,15.5555556 M70,11.6666667 C37.7844444,11.6666667 11.6666667,37.7844444 11.6666667,70 C11.6666667,73.9977778 12.0711111,77.8983333 12.8372222,81.6666667 L127.162778,81.6666667 C127.928889,77.8983333 128.333333,73.9977778 128.333333,70 C128.333333,37.7844444 102.215556,11.6666667 70,11.6666667 L70,11.6666667 Z" id="Shape" fill="#4788C7"></path>
          <path d="M70,126.388889 C42.6416667,126.388889 19.1722222,106.477778 14.5094444,79.7222222 L125.486667,79.7222222 C120.827778,106.477778 97.3583333,126.388889 70,126.388889 Z" id="Path" fill="#B6DCFE"></path>
          <path d="M123.126111,81.6666667 C117.728333,106.345556 95.6316667,124.444444 70,124.444444 C44.3683333,124.444444 22.2716667,106.345556 16.8738889,81.6666667 L123.126111,81.6666667 M127.753889,77.7777778 L12.2461111,77.7777778 C16.0572222,106.306667 40.4288889,128.333333 70,128.333333 C99.5711111,128.333333 123.942778,106.306667 127.753889,77.7777778 L127.753889,77.7777778 Z" id="Shape" fill="#4788C7"></path>
          <path d="M3.88888889,19.4444444 L3.88888889,3.88888889 L19.4444444,3.88888889 L19.4444444,0 L0,0 L0,19.4444444 L3.88888889,19.4444444 Z M136.111111,19.4444444 L140,19.4444444 L140,0 L120.555556,0 L120.555556,3.88888889 L136.111111,3.88888889 L136.111111,19.4444444 Z M136.111111,120.555556 L136.111111,136.111111 L120.555556,136.111111 L120.555556,140 L140,140 L140,120.555556 L136.111111,120.555556 Z M3.88888889,120.555556 L0,120.555556 L0,140 L19.4444444,140 L19.4444444,136.111111 L3.88888889,136.111111 L3.88888889,120.555556 Z" id="Shape" fill="#4788C7"></path>
          <path d="M138.055556,15.5555556 L138.055556,15.5555556 C139.125,15.5555556 140,16.4305556 140,17.5 L140,21.3888889 C140,22.4583333 139.125,23.3333333 138.055556,23.3333333 L138.055556,23.3333333 C136.986111,23.3333333 136.111111,22.4583333 136.111111,21.3888889 L136.111111,17.5 C136.111111,16.4305556 136.986111,15.5555556 138.055556,15.5555556 Z M138.055556,116.666667 L138.055556,116.666667 C139.125,116.666667 140,117.541667 140,118.611111 L140,122.5 C140,123.569444 139.125,124.444444 138.055556,124.444444 L138.055556,124.444444 C136.986111,124.444444 136.111111,123.569444 136.111111,122.5 L136.111111,118.611111 C136.111111,117.541667 136.986111,116.666667 138.055556,116.666667 Z M1.94444444,116.666667 L1.94444444,116.666667 C3.01388889,116.666667 3.88888889,117.541667 3.88888889,118.611111 L3.88888889,122.5 C3.88888889,123.569444 3.01388889,124.444444 1.94444444,124.444444 L1.94444444,124.444444 C0.875,124.444444 0,123.569444 0,122.5 L0,118.611111 C0,117.541667 0.875,116.666667 1.94444444,116.666667 Z M1.94444444,15.5555556 L1.94444444,15.5555556 C3.01388889,15.5555556 3.88888889,16.4305556 3.88888889,17.5 L3.88888889,21.3888889 C3.88888889,22.4583333 3.01388889,23.3333333 1.94444444,23.3333333 L1.94444444,23.3333333 C0.875,23.3333333 0,22.4583333 0,21.3888889 L0,17.5 C0,16.4305556 0.875,15.5555556 1.94444444,15.5555556 Z M17.5,0 L21.3888889,0 C22.4583333,0 23.3333333,0.875 23.3333333,1.94444444 L23.3333333,1.94444444 C23.3333333,3.01388889 22.4583333,3.88888889 21.3888889,3.88888889 L17.5,3.88888889 C16.4305556,3.88888889 15.5555556,3.01388889 15.5555556,1.94444444 L15.5555556,1.94444444 C15.5555556,0.875 16.4305556,0 17.5,0 Z M118.611111,0 L122.5,0 C123.569444,0 124.444444,0.875 124.444444,1.94444444 L124.444444,1.94444444 C124.444444,3.01388889 123.569444,3.88888889 122.5,3.88888889 L118.611111,3.88888889 C117.541667,3.88888889 116.666667,3.01388889 116.666667,1.94444444 L116.666667,1.94444444 C116.666667,0.875 117.541667,0 118.611111,0 Z M17.5,136.111111 L21.3888889,136.111111 C22.4583333,136.111111 23.3333333,136.986111 23.3333333,138.055556 L23.3333333,138.055556 C23.3333333,139.125 22.4583333,140 21.3888889,140 L17.5,140 C16.4305556,140 15.5555556,139.125 15.5555556,138.055556 L15.5555556,138.055556 C15.5555556,136.986111 16.4305556,136.111111 17.5,136.111111 Z M118.611111,136.111111 L122.5,136.111111 C123.569444,136.111111 124.444444,136.986111 124.444444,138.055556 L124.444444,138.055556 C124.444444,139.125 123.569444,140 122.5,140 L118.611111,140 C117.541667,140 116.666667,139.125 116.666667,138.055556 L116.666667,138.055556 C116.666667,136.986111 117.541667,136.111111 118.611111,136.111111 Z" id="Shape" fill="#4788C7"></path>
          <circle id="Oval" fill="url(#linearGradient-1)" cx="70" cy="70" r="54.4444444"></circle>
        </g>
    </g>
  </SpinnerSVG>
)

const animation = keyframes`
  20%, 100% {
    transform: scaleX(1) scaleX(1);
    background: #efefef;
  }
  0% {
    transform: scaleX(1) scaleX(1);
    background: #efefef;
  }
  10% {
    transform: scaleX(1.5) scaleX(1);
    background: #D8F0FF;
  }
`

const spinner = keyframes`
  20%, 100% {
    
  }
  0% {
    
  }
  10% {
    transform: rotate(180deg)
  }
`

const Connector = styled(Box)`
  position: relative;
  top: 7px;
  animation: ${animation} 4s infinite linear;
`

const SpinnerSVG = styled.svg`
  position: relative;
  left: 30px;
  animation: ${spinner} 5s infinite linear;
`

export default DataFlow